/* eslint-disable */
import { api } from './../../api.js';
import {vue_instance} from "../../main";
//import api_routes from './../../api_routes.js';

const state = {
};

const getters = {

}

const mutations = {
}

const actions = {
    createLaboratorio : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('laboratorios', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLaboratorios : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('laboratorios', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLaboratorio : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('laboratorios/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteLaboratorio : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('laboratorios/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    updateLaboratorio : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.patch('laboratorios/' + data.id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLaboratorioFtn : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('laboratorios/' + data.filters.id + '/ftns', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLaboratoriosSelect : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('laboratorios/select', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLaboratorioClientes : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('laboratorios/' + data.filters.laboratorio_id + '/clientes', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    addLaboratorioClientes : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.post('laboratorios/' + data.laboratorio_id + '/clientes', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteLaboratorioCliente : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('laboratorios/' + data.filters.laboratorio_id + '/clientes/' + data.filters.cliente_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    deleteLaboratorioFtn : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.delete('laboratorios/' + data.filters.laboratorio_id + '/ftns/' + data.filters.ftn_id, data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
    getLaboratorioSelectClientes : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.get('laboratorios/' + data.filters.laboratorio_id + '/clientes/select', data).then((res) => {
                resolve(res);
            }).catch((error) => {
                reject(error.response);
            });
        });
    },
}

export default {
    state,
    actions,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/LaboratorioModule.js